export const notificationSnackBarGetter = state => {
  return state.snackbar
}

export const notificationDialogGetter = state => {
  return state.dialog
}
